import React, { memo, useCallback, useMemo } from 'react';

import PropTypes from 'prop-types';

import { getMarks, getValueWithText } from 'utils';

import { Slider, Box } from './style';

export function SliderCustom({
  value,
  setValue,
  min,
  max,
  step,
  text,
  markStep,
  toFixedValue,
  markStepLabels,
  orientation,
}) {
  const onChange = useCallback((e, value) => setValue(value), []);
  const currentMarks = useMemo(
    () => getMarks(min, max, markStep, text, toFixedValue, markStepLabels),
    [min, max, markStep, text, toFixedValue, markStepLabels],
  );

  return (
    <Box className="slider-component">
      <Slider
        aria-labelledby="track-true-slider"
        value={value}
        marks={currentMarks}
        valueLabelDisplay="on"
        min={min}
        max={max}
        step={step}
        onChange={onChange}
        valueLabelFormat={getValueWithText(text)}
        orientation={orientation}
      />
    </Box>
  );
}

SliderCustom.propTypes = {
  value: PropTypes.number.isRequired,
  setValue: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  markStep: PropTypes.number,
  text: PropTypes.string,
  toFixedValue: PropTypes.number,
  markStepLabels: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    }),
  ),
  orientation: PropTypes.string,
};

SliderCustom.defaultProps = {
  min: 0,
  max: 100,
  step: 10,
  markStep: 10,
  text: '%',
  toFixedValue: 0,
  markStepLabels: null,
  orientation: 'horizontal',
};

export const SliderComponent = memo(SliderCustom);
